import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IUserSettings } from '@api'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  updateUserSettings: {
    settings: IUserSettings
  }
}

const mutateHandler = handleFetchResult<IPayload, IUserSettings>({
  handler: (data) => data.updateUserSettings.settings,
  name: 'User Settings',
})

export const updateSettings = (
  settings: Partial<{ [key in keyof IUserSettings]: any }>
): Promise<IUserSettings> => {
  const variables = {
    input: {
      settings,
    },
  }
  return client.gql.mutate({ mutation, variables }).then(mutateHandler)
}

const mutation = gql`
  mutation ($input: UpdateUserSettingsInput!) {
    updateUserSettings(input: $input) {
      settings {
        healthNoticeEnabled
        favoriteFloors
        defaultFloor
      }
    }
  }
`
